import React, { Component } from "react"

import {
    genericBarPieScene,
    genericLineScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import { VoteDatePickerStartFilter, VoteDatePickerEndFilter } from "shared/search/containers/Filter/VoteFilters"

/* *****************************************************************
 * MAPS
 ******************************************************************* */

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export const VoteInIssuesBarPieScene = (props) => genericBarPieScene(props)
VoteInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "voteInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Votes tagged to Issue",
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
export class VoteTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "voteTrendsScene",
        dateStartId: VoteDatePickerStartFilter.defaultProps.uniqueFilterId,
        dateEndId: VoteDatePickerEndFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
    }

    render() {
        return genericLineScene(this.props)
    }
}
